import React from "react";
import { Location } from "../Location";
import { SubVersionForm } from "@contracts/CustomerContractProfile/components/SubVersionsTable/form/SubVersionForm";
import { FormData } from "@contracts/CustomerContractProfile/components/SubVersionsTable/form/utils";

interface Params {
  contractId: string;
  subVersionId: string;
  action: string;
}

export class CustomerContractSubVersionEditorLocation extends Location<Params> {
  initialValues: FormData = null;
  onSubmitCB = null;
  constructor(
    contractId: string,
    subVersionId: string,
    action: string,
    initialValues?: FormData,
    onSubmitCB?: () => void
  ) {
    super({ subVersionId, contractId, action });
    this.initialValues = initialValues;
    this.onSubmitCB = onSubmitCB;
  }

  render(): React.ReactElement<any> {
    return (
      <SubVersionForm
        subVersionId={this.params.subVersionId}
        contractId={this.params.contractId}
        action={this.params.action}
        initialValues={this.initialValues}
        onSubmitCB={this.onSubmitCB}
      />
    );
  }

  toURI() {
    const { subVersionId, contractId } = this.params;
    return `/customer_contract/${contractId}/subVersion/${subVersionId || "new"} `;
  }
}
